import { signOut } from 'firebase/auth';
import React from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useAuthState, } from 'react-firebase-hooks/auth';
import auth from '../../firebase.init';
import CustomLink from '../CustomLink/CustomLink'
import './Header.css'

const Header = () => {
  const [user]=useAuthState(auth);
  const handleSignOut = () =>{
    signOut(auth);
}
    return (
        <div className='nav-bar position-sticky fixed-top'>
<Navbar collapseOnSelect expand="lg" >
  <Container>
  <Navbar.Brand className='text-info' href="/"> Dhananjoy's <span className='text-danger'> Edu Center</span></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="me-auto">
     
    </Nav>
    <Nav>
      <CustomLink className="px-3" to="/">Home</CustomLink>
      <CustomLink className="px-3" to="blogs">Blogs</CustomLink>
      <CustomLink className="px-3" to="services">Services</CustomLink>
      <CustomLink className="px-3" to="reviews">Reviews</CustomLink>
      <CustomLink className="px-3" to="checkout">Check Out</CustomLink>
      <CustomLink className="px-3" to="/about">About Me</CustomLink>


      {   
        user? <span className='text-warning px-3'>Welcome! <span className='text-info pe-3'> {user?.displayName || user?.email}</span> <button onClick={handleSignOut}>Sign Out</button> </span> : <>
        <CustomLink className="px-3" to="login">Log In</CustomLink>
        <CustomLink className="px-3" to="signup"> Sign Up</CustomLink></>
    }
     
   
      
    </Nav>
  </Navbar.Collapse>
  </Container>
</Navbar>




        </div>
        
    );
};

export default Header;